import {
  AttachMoney,
  Calculate,
  Description,
  Warning,
} from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import StatCard from 'lib/designSystem/Charts/StatCard';
import { BASE_COLORS } from 'lib/functions/const/colors';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

import { useFundSummaryData } from '../../context/FundSummaryDataContext';

const NomineesDetail: React.FC = () => {
  const {
    nomineesSummary: data,
    overdueAndDueDates: overdueData,
    isPendingOverdueAndDueDates: isPendingOverdue,
    isPendingNomineesSummary: isPending,
    isErrorNomineesSummary: isError,
  } = useFundSummaryData();

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {isError && (
            <Box sx={{ py: 2, color: 'error.main' }}>
              Error al cargar detalle de nóminas.
            </Box>
          )}
          {!isError && (
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <StatCard
                  label="Nóminas activas"
                  value={data ? (data.activeNominees ?? 0) : 0}
                  valueLabel={
                    data?.totalNominees
                      ? `/${data.totalNominees} totales (${(((data.activeNominees ?? 0) / data.totalNominees) * 100).toFixed(1)}%)`
                      : ''
                  }
                  color={BASE_COLORS.blue}
                  icon={<Description sx={{ fontSize: 24 }} />}
                  loading={isPending}
                />
              </Grid>
              <Grid item xs={3}>
                <StatCard
                  label="Monto total nóminas"
                  value={data ? formatMoney(data.totalAmount ?? 0) : ''}
                  valueLabel="CLP"
                  color={BASE_COLORS.green}
                  icon={<AttachMoney sx={{ fontSize: 24 }} />}
                  loading={isPending}
                />
              </Grid>
              <Grid item xs={3}>
                <StatCard
                  label="Monto total NC cedidas"
                  value={
                    data
                      ? formatMoney(data.totalCreditNoteAmountCededToFunds ?? 0)
                      : ''
                  }
                  valueLabel="CLP"
                  color={BASE_COLORS.purple}
                  icon={<Calculate sx={{ fontSize: 24 }} />}
                  loading={isPending}
                />
              </Grid>
              <Grid item xs={3}>
                <StatCard
                  label="Monto en mora"
                  value={
                    overdueData
                      ? formatMoney(overdueData.totalOverdueAmount ?? 0)
                      : ''
                  }
                  valueLabel="CLP"
                  color={BASE_COLORS.red}
                  icon={<Warning sx={{ fontSize: 24 }} />}
                  loading={isPendingOverdue}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default NomineesDetail;
